import { isEmpty, pathOr } from 'ramda';
import { useMutation } from '@apollo/react-hooks';

import { COMPLETE_SESSION_ACTIVITY } from 'apollo/mutations';
import { useToggle } from 'utils/hooks/useToggle';
import { KEYS } from 'components/evieOnboarding/utils/constants';
import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import { useGetParams } from 'components/evieOnboarding/utils/useGetParams';
import { useEvieAppContext } from '../EvieAppProvider';
import { useEvieHomeContext } from '../EvieHomeProvider';
import { useCompletedActivity } from './useCompletedActivity';
import { HOME_STATUS } from '../utils';

export const useCompleteSessionActivity = () => {
  const { activeProgram: { id = '' } = {}, refetch } = useEvieAppContext();
  const {
    activityType,
    selectedTask: { id: activityId } = {},
    setActivityType,
    changeHomeStatus,
  } = useEvieHomeContext();
  const { completedActivity } = useCompletedActivity(activityId);

  const [userToken] = useLocalStorage(KEYS.USER_TOKEN);
  const { urlToken } = useGetParams();
  const token = userToken || urlToken;
  const [completeSessionActivity] = useMutation(COMPLETE_SESSION_ACTIVITY);

  const [sessionCompleted, setSessionCompleted] = useToggle();

  const handleCompleteSession = async () => {
    const response = await completeSessionActivity({
      variables: { activityId, activityType, patientProgramId: id },
      context: {
        headers: {
          authorization: token ? `Bearer ${token}` : '',
          role: 'individual',
        },
      },
    });

    const errors = pathOr([], ['data', 'completeSessionActivity', 'errors'])(response);
    const emptyErrors = isEmpty(errors);

    if (emptyErrors) {
      setSessionCompleted();
      if (completedActivity) {
        setActivityType(null);
      }
      changeHomeStatus(completedActivity ? HOME_STATUS.IDLE : HOME_STATUS.FEEDBACK);
      refetch();
    }
  };
  return { completeSession: handleCompleteSession, onCompleteSession: setSessionCompleted, sessionCompleted };
};
